type Irai = {
    id: string;
    statusId: string | number
    status: string;
    formNo: string | number;
    slideOriginNum: string | number; // Optional field for slide origin number
    procCnt: string | number; // Optional field for procedure count
    patientFirstName: string;
    patientLastName: string;
    patientName: string; // Optional field for full patient name
    anonymousId: string;
    patientBirthday: string | Date | null;
    patientGender: string | number;
    organizationId: string | number; // Optional field for organization ID  
    organizationName: string;
    approvalDoctorId: string;
    approvalDoctorName: string;
    dataApprovalDoctorId: string;
    dataApprovalDoctorName: string;
    specimenId: string | null;
    sampleDate: string;
    lymphStsId: string | number;
    esStsId: string | number;
    prStsId: string | number;
    her2StsId: string | number;
    diagnosisId: string | number;
    iraiDate: string | Date | null;
    approvalDate: string | Date | null;
    ki67Per: number | string | null;
    tclass: string | number;
    nclass: string | number;
    mclass: string | number;
    menstruation: string | number;
    tumorGrade: string | number;
    biopsyId: string | number;
    submissionDate: string | Date | null;
    patientId: string | null; // Patient karute number
    preFailureId: string | null;
    failureReason: string | null;
};

type MasterStatus = {
    statusId: number;
    status: string;
};

type MasterItem = {
    id: number;
    name: string;
};

const iraiHeader: Irai = {
    id: '依頼ID',
    preFailureId: '前回失敗依頼ID',
    status: '依頼進捗状況',
    specimenId: '検体ID',
    patientId: '患者カルテ番号',
    patientName: '患者氏名', // Optional field for full patient name
    patientBirthday: '生年月日',
    patientGender: '性別',
    iraiDate: '依頼日',
    approvalDate: '承認日',
    sampleDate: '検体採取日',
    tumorGrade: '腫瘍グレード',
    esStsId: 'ER',
    prStsId: 'PR',
    her2StsId: 'HER2',
    lymphStsId: 'リンパ節',
    ki67Per: 'Ki-67状況',
    menstruation: '月経状況',
    tclass: 'T分類',
    nclass: 'N分類',
    mclass: 'M分類',
    approvalDoctorName: '依頼/承認医師名',
    anonymousId: '匿名化ID',
    approvalDoctorId: '依頼/承認医師ID',
    dataApprovalDoctorId: 'データ承認医師ID',
    dataApprovalDoctorName: 'データ承認医師名',
    diagnosisId: '診断',
    formNo: '入力中フォーム',
    organizationId: '施設番号', // Optional field for organization ID
    organizationName: '施設名',
    patientFirstName: '患者名',
    patientLastName: '患者姓',
    procCnt: '0',
    slideOriginNum: '',
    statusId: 0,
    biopsyId: '生検',
    submissionDate: '検体提出日',
    failureReason: '失敗理由',
};

export type { Irai, MasterItem, MasterStatus };
export { iraiHeader };
